import React from 'react'
import { Spin } from 'antd'
import TableRow from './TableRow'

const ProductProcessTable = ({ loading, error, listIssues, reload }) => {
    const _renderTableContent = () => {
        if (listIssues.length === 0 && !error) {
            return <tr>
                <td colSpan={7}>No data</td>
            </tr>
        }

        if (!!error) {
            return <tr>
                <td colSpan={7} className='text-danger'>{error}</td>
            </tr>
        }

        return listIssues.length > 0 && listIssues.map((item) => {
            return <TableRow
                key={item._id}
                item={item}
                reload={reload}
            />
        })
    }

    return (
        <div className='ProductProcessTable SkuTable'>
            <Spin tip="Loading..." spinning={loading}>
                <table className="table table-striped">
                    <thead className="TableHead">
                        <tr>
                            <th className="Process">Quy trình</th>
                            <th className="Stage">Công đoạn</th>
                            <th className="Partner">Đối tác sản xuất</th>
                            <th className="Status">Trạng thái</th>
                            <th className="Created">Ngày tạo</th>
                            <th className="Updated">Ngày cập nhật</th>
                            <th className="Action">Hành động</th>
                        </tr>
                    </thead>
                    <tbody className="TableBody">
                        {_renderTableContent()}
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default ProductProcessTable